module.exports = __webpack_public_path__ + "img/add_img.6936681e.png";